import { duplicateTasks as _duplicateTasks } from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { Task } from 'shared/types/task';

import { getAuthentication, getDatabase } from './helpers';

export const duplicateTasks = async (tasks: Task[]) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const uid = user.uid;

  return _duplicateTasks({
    tasks,
    userId: uid,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DuplicateTasks,
        error,
        uid,
      }),
  });
};
